import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';

// Sale Invoice
import PrintBtnSaleInvoicePdf from "../../Invoices/Sale/PrintBtnSaleInvoicePdf";
import DownloadBtnSaleInvoicePdf from "../../Invoices/Sale/DownloadBtnSaleInvoicePdf";

// Sale Return / Credit Note Invoice
import DownloadBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/DownloadBtnSaleReturnInvoicePdf";
import PrintBtnSaleReturnInvoicePdf from "../../Invoices/SaleReturn/PrintBtnSaleReturnInvoicePdf";

// Purchase Invoice
import DownloadBtnPurchaseInvoicePdf from "../../Invoices/Purchase/DownloadBtnPurchaseInvoicePdf";
import PrintBtnPurchaseInvoicePdf from "../../Invoices/Purchase/PrintBtnPurchaseInvoicePdf";

// Purchase Return / Debit Note Invoice
import DownloadBtnPurchaseReturnInvoicePdf from "../../Invoices/PurchaseReturn/DownloadBtnPurchaseReturnInvoicePdf";
import PrintBtnPurchaseReturnInvoicePdf from "../../Invoices/PurchaseReturn/PrintBtnPurchaseReturnInvoicePdf";

// Payment In Invoice
import DownloadBtnPaymentInPdf from "../../Invoices/PaymentIn/DownloadBtnPaymentInPdf";
import PrintBtnPaymentInPdf from "../../Invoices/PaymentIn/PrintBtnPaymentInPdf";

// Payment Out Invoice
import DownloadBtnPaymentOutPdf from "../../Invoices/PaymentOut/DownloadBtnPaymentOutPdf";
import PrintBtnPaymentOutPdf from "../../Invoices/PaymentOut/PrintBtnPaymentOutPdf";

// Expense Invoice
import DownloadBtnExpensePdf from "../../Invoices/Expense/DownloadBtnExpensePdf";
import PrintBtnExpensePdf from "../../Invoices/Expense/PrintBtnExpensePdf";

// Other Income Invoice
import DownloadBtnOtherIncomeInvoicePdf from "../../Invoices/OtherIncome/DownloadBtnOtherIncomeInvoicePdf";
import PrintBtnOtherIncomeInvoicePdf from "../../Invoices/OtherIncome/PrintBtnOtherIncomeInvoicePdf";

// Sale Order Invoice
import DownloadBtnSaleOrderInvoicePdf from "../../Invoices/SaleOrder/DownloadBtnSaleOrderInvoicePdf";
import PrintBtnSaleOrderInvoicePdf from "../../Invoices/SaleOrder/PrintBtnSaleOrderInvoicePdf";

// Purchase Order Invoice
import DownloadBtnPurchaseOrderInvoicePdf from "../../Invoices/PurchaseOrder/DownloadBtnPurchaseOrderInvoicePdf";
import PrintBtnPurchaseOrderInvoicePdf from "../../Invoices/PurchaseOrder/PrintBtnPurchaseOrderInvoicePdf";

// Estimate Invoice
import DownloadBtnSaleEstimateInvoicePdf from "../../Invoices/SaleEstimate/DownloadBtnSaleEstimateInvoicePdf";
import PrintBtnSaleEstimateInvoicePdf from "../../Invoices/SaleEstimate/PrintBtnSaleEstimateInvoicePdf";

// Challan Invoice
import DownloadBtnChallanPdf from "../../Invoices/Challan/DownloadBtnChallanPdf";
import PrintBtnChallanInvoicePdf from "../../Invoices/Challan/PrintBtnChallanInvoicePdf";

let _signingId = "0";
let _businessId = "0";
let _companyId = "0";


let columns = [
  {
    label: "Name",
    field: "name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Name",
    },
  },
  {
    label: "Invoice Date.",
    field: "invoice_date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Invoice Date",
    },
  },
  {
    label: "Ref No.",
    field: "ref_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Ref No.",
    },
  },
  {
    label: "Type",
    field: "sale_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Type",
    },
  },
  {
    label: "Total",
    field: "total_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Total",
    },
  },
  {
    label: "Money In",
    field: "money_in",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Money In",
    },
  },
  {
    label: "Money Out",
    field: "money_out",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Money Out",
    },
  },
  {
    label: "Action",
    field: "actionExtra",
    width: 100,
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    
    let _UserSession = localStorage.getItem("vs_UserSession");
    if (_UserSession!=undefined || _UserSession!=null) {
      _UserSession = JSON.parse(_UserSession);
      _signingId = _UserSession.loginId;
      _businessId = _UserSession.tokenKey;
    }

    let _companySession = localStorage.getItem("vs_UserCompanySession");
    if (_companySession!=undefined || _companySession!=null) {
      _companySession = JSON.parse(_companySession);
      _businessId = _companySession.business_id;
      _companyId = _companySession.company_id;
    }
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,

      paidAmount: 0,
      unpaidAmount: 0,
      total: 0,

      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      dateLabel: "",

      pageCount : 10,
      page : 1,
      totalCount  : 0,
      pageShow  : 0,
      setPage : 1,
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getSaleListData(this.state.activeTransactionKey,this.state.page);
  }

  // Helper method to get invoice buttons based on transaction type
  getInvoiceButtons(transactionType, transactionId) {
    const loadingHandler = (isLoading) => this.setState({ isPdfLoading: isLoading });

    switch (transactionType) {
      case 'SALE':
        return {
          downloadBtn: <DownloadBtnSaleInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnSaleInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/salePdfDialog/?auth=' + transactionId
        };
      case 'CREDIT NOTE':
        return {
          downloadBtn: <DownloadBtnSaleReturnInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnSaleReturnInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/saleReturnPdfDialog/?auth=' + transactionId
        };
      case 'PURCHASE':
        return {
          downloadBtn: <DownloadBtnPurchaseInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnPurchaseInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/purchasePdfDialog/?auth=' + transactionId
        };
      case 'DEBIT NOTE':
        return {
          downloadBtn: <DownloadBtnPurchaseReturnInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnPurchaseReturnInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/purchaseReturnPdfDialog/?auth=' + transactionId
        };
      case 'PAYMENT-IN':
        return {
          downloadBtn: <DownloadBtnPaymentInPdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnPaymentInPdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/paymentInPdfDialog/?auth=' + transactionId
        };
      case 'PAYMENT-OUT':
        return {
          downloadBtn: <DownloadBtnPaymentOutPdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnPaymentOutPdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/paymentOutPdfDialog/?auth=' + transactionId
        };
      case 'EXPENSE':
        return {
          downloadBtn: <DownloadBtnExpensePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnExpensePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/expensePdfDialog/?auth=' + transactionId
        };
      case 'OTHER INCOME':
      case 'Other Income':
        return {
          downloadBtn: <DownloadBtnOtherIncomeInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnOtherIncomeInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/otherIncomePdfDialog/?auth=' + transactionId
        };
      case 'SALE ORDER':
        return {
          downloadBtn: <DownloadBtnSaleOrderInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnSaleOrderInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/saleOrderPdfDialog/?auth=' + transactionId
        };
      case 'PURCHASE ORDER':
        return {
          downloadBtn: <DownloadBtnPurchaseOrderInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnPurchaseOrderInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/purchaseOrderPdfDialog/?auth=' + transactionId
        };
      case 'ESTIMATE':
        return {
          downloadBtn: <DownloadBtnSaleEstimateInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnSaleEstimateInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/saleEstimatePdfDialog/?auth=' + transactionId
        };
      case 'DELIVERY CHALLAN':
        return {
          downloadBtn: <DownloadBtnChallanPdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnChallanInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/challanPdfDialog/?auth=' + transactionId
        };
      default:
        // Default to Sale invoice for unknown types
        return {
          downloadBtn: <DownloadBtnSaleInvoicePdf auth={transactionId} loading={loadingHandler} />,
          printBtn: <PrintBtnSaleInvoicePdf auth={transactionId} loading={loadingHandler} />,
          previewUrl: '/business/salePdfDialog/?auth=' + transactionId
        };
    }
  }

  // Helper method to get edit URLs based on transaction type
  getEditUrls(transactionType, transactionId) {
    switch (transactionType) {
      case 'SALE':
        return {
          editUrl: global.webUrl + "business/add-sale/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-sale/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'CREDIT NOTE':
        return {
          editUrl: global.webUrl + "business/add-sale-credit-note/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-sale-return-duplicate/?auth=" + transactionId
        };
      case 'PURCHASE':
        return {
          editUrl: global.webUrl + "business/add-purchase/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-purchase/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'DEBIT NOTE':
        return {
          editUrl: global.webUrl + "business/add-debit-note/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-debit-note/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'PAYMENT-IN':
        return {
          editUrl: global.webUrl + "business/add-receive-payment-in/?auth=" + transactionId,
          duplicateUrl: null
        };
      case 'PAYMENT-OUT':
        return {
          editUrl: global.webUrl + "business/add-make-payment-out/?auth=" + transactionId,
          duplicateUrl: null
        };
      case 'EXPENSE':
        return {
          editUrl: global.webUrl + "business/add-expense/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-expense/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'OTHER INCOME':
      case 'Other Income':
        return {
          editUrl: global.webUrl + "business/add-other-income/?auth=" + transactionId,
          duplicateUrl: null
        };
      case 'SALE ORDER':
        return {
          editUrl: global.webUrl + "business/add-sale-order/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-sale-order/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'PURCHASE ORDER':
        return {
          editUrl: global.webUrl + "business/add-purchase-order/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-purchase-order/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'ESTIMATE':
        return {
          editUrl: global.webUrl + "business/add-sale-estimate/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-sale-estimate/?auth=" + transactionId + '&tType=DUPLICATE'
        };
      case 'DELIVERY CHALLAN':
        return {
          editUrl: global.webUrl + "business/add-challan/?auth=" + transactionId,
          duplicateUrl: null
        };
      default:
        return {
          editUrl: global.webUrl + "business/add-sale/?auth=" + transactionId,
          duplicateUrl: global.webUrl + "business/add-sale/?auth=" + transactionId + '&tType=DUPLICATE'
        };
    }
  }

  getSaleListData(_type,_page) {
    let _transArray = [];
    let _paidAmt = 0;
    let _unpaidAmt = 0;
    let _totalAmt = 0;
    let _totalMoneyInOut  = 0;
    let _totalMoneyIn  = 0; 
    let _totalMoneyOut  = 0; 

    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      type: _type,
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      page: _page,
      pageCount: this.state.pageCount,
    }); 

    PostData(global.userDayBookTransactionList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success == false) {
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            paidAmount: _paidAmt,
            unpaidAmount: _unpaidAmt,
            total: _totalAmt,
            countList: 0,
            totalTransAmt: 0,
            totalMoneyIn: 0,
            totalMoneyOut: 0,
            totalMoneyInOut: 0,
            totalBalanceAmt: 0
          });
        } else {
          if (responseJson.response) {
            _transArray = responseJson.response;
            _transArray.map((itm, i) => {
              _unpaidAmt = parseFloat(_unpaidAmt) + parseFloat(itm.balance);
              _paidAmt = parseFloat(_paidAmt) + parseFloat(itm.received_amount);
              _totalAmt = parseFloat(_totalAmt) + parseFloat(itm.total_amount);
              _totalMoneyIn = responseJson.totalMoneyIn ? responseJson.totalMoneyIn : 0;
              _totalMoneyOut = responseJson.totalMoneyOut ? responseJson.totalMoneyOut : 0;
              _totalMoneyInOut = parseFloat(_totalMoneyIn) + parseFloat(_totalMoneyOut);

            });
          }
          //_totalAmt = parseFloat(_paidAmt) + parseFloat(_unpaidAmt);
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            paidAmount: _paidAmt,
            unpaidAmount: _unpaidAmt,
            total: _totalAmt,
            countList: responseJson.countList,
            totalTransAmt: responseJson.totalTransAmt,
            totalMoneyIn: responseJson.totalMoneyIn,
            totalMoneyOut: responseJson.totalMoneyOut,
            totalBalanceAmt: responseJson.totalBalanceAmt,
            totalMoneyInOut: _totalMoneyInOut,
            totalCount:responseJson.totalCount,
            pageShow:responseJson.pageShow
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
    let dataList = [];
    let rows = [];
    if (this.state.isLoaded == true) {
      let _transDetails = this.state.transactionArrayFilter;
      if (_transDetails.length > 0) {
        _transDetails.map((value) => {
          let _textShow = value.type === "SALE" ? "Sale" : value.type;

          // Get invoice buttons and URLs based on transaction type
          const invoiceButtons = this.getInvoiceButtons(value.type, value.id);
          const editUrls = this.getEditUrls(value.type, value.id);

          let _actionExtra = (
            <div className="btn-group" role="group">
              <button
                type="button"
                id="btnGroupVerticalDrop3"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-ellipsis-v"></i>
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="btnGroupVerticalDrop1"
              >
                {/* View/Edit Details */}
                <a className="dropdown-item" href={editUrls.editUrl}>
                  View/Edit Details
                </a>

                {/* Duplicate - only if available */}
                {editUrls.duplicateUrl && (
                  <a className="dropdown-item" href={editUrls.duplicateUrl}>
                    Duplicate
                  </a>
                )}

                {/* Sale-specific actions */}
                {value.type === "SALE" && (
                  <>
                    <a
                      className="dropdown-item"
                      href={global.webUrl + "business/add-receive-payment-in/?auth=" + value.id}
                    >
                      Receive Payment
                    </a>
                    {/* canCreateReturn is false once every line is fully returned */}
                    {value.canCreateReturn !== false && (
                      <a
                        className="dropdown-item"
                        href={global.webUrl + 'business/add-sale-credit-note?auth=' + value.id + "&tType=CREDIT NOTE&isConvert=true"}
                      >
                        Convert to Return
                      </a>
                    )}
                    <a
                      className="dropdown-item"
                      href={global.webUrl + "business/challanPdfDialog/?auth=" + value.id}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Preview as Delivery Challan
                    </a>
                  </>
                )}

                {/* Credit Note / Debit Note - Make Payment */}
                {(value.type === "CREDIT NOTE" || value.type === "DEBIT NOTE") && (
                  <a
                    className="dropdown-item"
                    href={global.webUrl + "business/add-make-payment-out/?auth=" + value.id}
                  >
                    Make Payment
                  </a>
                )}

                {/* Purchase-specific actions */}
                {value.type === "PURCHASE" && (
                  <>
                    <a
                      className="dropdown-item"
                      href={global.webUrl + "business/add-make-payment-out/?auth=" + value.id}
                    >
                      Make Payment
                    </a>
                    {/* canCreateReturn is false once every line is fully returned */}
                    {value.canCreateReturn !== false && (
                      <a
                        className="dropdown-item"
                        href={global.webUrl + 'business/add-debit-note?auth=' + value.id + "&tType=DEBIT NOTE&isConvert=true"}
                      >
                        Convert to Return
                      </a>
                    )}
                  </>
                )}

                {/* Delete */}
                <a
                  className="dropdown-item"
                  href="javascript:void(0)"
                  data-id={value.id}
                  onClick={this.clickToDelete.bind(this, value.id, value.type)}
                >
                  Delete
                </a>

                {/* Invoice buttons - Download, Preview, Print */}
                {invoiceButtons.downloadBtn}
                <Link className="dropdown-item" to={invoiceButtons.previewUrl} target="_blank">
                  Preview
                </Link>
                {invoiceButtons.printBtn}
              </div>
            </div>
          );
          
          rows.push({
            srNo: value.srNo,
            invoice_date: moment(value.invoice_date).format("YYYY-MM-DD"),
            ref_no: value.invoice_no, //value.customPrefix+' #'+value.invoice_no,
            name: value.party_name,
            sale_type: _textShow,
            payment_type: value.payment_type,
            total_amount: numberFormat(value.total_amount),
            money_in: numberFormat(value.money_in),
            money_out: numberFormat(value.money_out),
            actionExtra: _actionExtra,
          });
        });
      }
    }

    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    }, () => {
      this.getSaleListData(this.state.activeTransactionKey, this.state.page);
    });
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData(this.state.activeTransactionKey,this.state.page);
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }


  exportData = (event) =>{
    let _itemDetails = this.state.itemArray;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {

        let newData = {
          'Name': data.invoice_date,
          'Ref No': data.order_number,
          'Type': data.invoice_no,
          'Total': data.party_name,
          'Money In': data.party_phone,
          'Money Out': data.type
        }
         return newData;
      });

      let totalAmountRow = {
        'Name': '',
        'Ref No': '',
        'Type': '',
        'Total': '',
        'Money In': '',
        'Money Out': ''
      };

      _itemDetails.push({});
      _itemDetails.push(totalAmountRow);
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Day Book Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_daybook_report_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }


  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Day Book Report</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-9">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: moment(this.state.startDate),
                              endDate: moment(this.state.endDate),
                              locale: {
                                format: 'YYYY-MM-DD'
                              },
                              ranges: {
                                'Today': [moment(), moment()],
                                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                              }
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input type="text" className="form-control col-7" style={{ display: "inline-block" }} />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                        Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                    
                    <div className="row items-push">
                      <div className="row col-lg-12">                           
                        <div className="col-lg-3">                          
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'green'}}>
                                      Total Money In : {this.state.totalMoneyIn}
                                  </div> 
                                </div>
                              </div>
                          </div>
                        </div>
                                          
                        <div className="col-lg-3">                          
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'red'}}>
                                      Total Money Out : {this.state.totalMoneyOut}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                                          
                        <div className="col-lg-6">                          
                          <div className="row pb-20 pull-right">
                              <div className="text-right">
                                <div className="js-appear-enabled text-center">
                                  <div className="" style={{color : 'green'}}>
                                  Total Money In - Total Money Out : {this.state.totalMoneyInOut}
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>                          
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                                            <i className="fa fa-plus-circle"></i> Add Sale
                                        </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[1,5,10]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      pagingBottom={false}
                      data={this.loadTranscListing()}
                    />
                  </div>
                  
                  <div className="block-content">
                    <div style={{float : 'left', marginTop : '-45px'}}>
                        <PaginationControl
                            between={this.state.pageCount}
                            total={this.state.totalCount}
                            limit={this.state.pageCount}
                            changePage={(page) => {
                            this.setState({setPage:page}); 
                            this.getSaleListData(this.state.activeTransactionKey,page); 
                            }}
                            ellipsis={3}
                            activeClass={this.state.setPage}
                            page={this.state.setPage}
                        />
                    </div>
                    
                </div>
                
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
